const PROVIDER_ARTWORK = {
    '6901d8fc75053432a90a22ad:68e8cb08b06a0c9bb6cbec31': { asset: 'bnb', network: 'bsc' },
    '63d7d3b681c7f9e193bcdad5:63da349c7a40a721a6e0a221': {
        asset: 'btc',
        network: 'bitcoin',
    },
    '69c3d8eb13771bc7283510f1:69bd0f56561cac6630704202': { asset: 'doge', network: 'doge' },
    '692720c0651ba1a947d90b9b:691ef0e1cb28e3f376a87008': {
        asset: 'eth',
        network: 'abstract',
    },
    '68ff3a87b06a0c9bb6cbec70:68e8c8fbb06a0c9bb6cbec2d': {
        asset: 'eth',
        network: 'arbitrum',
    },
    '6729d9a415f34893ea4cad91:671a2d7168ef24934ca70622': { asset: 'eth', network: 'base' },
    '63d7d3fe81c7f9e193bcdad6:63430c8348c610068bcdc443': {
        asset: 'eth',
        network: 'ethereum',
    },
    '69272180651ba1a947d90b9c:691ef0f4cb28e3f376a87009': {
        asset: 'eth',
        network: 'hyperliquid',
    },
    '69bc09201ae6498e13edf8ba:69bc091f1ae6498e13edf8b7': {
        asset: 'eth',
        network: 'megaeth',
    },
    '69af01ada9df2b6d908f9ba4:69af01ada9df2b6d908f9ba3': {
        asset: 'hype',
        network: 'hypercore',
    },
    '6658711bbaaa58e2e734f731:63430c8348c610068bcdc43c': {
        asset: 'pyusd',
        network: 'solana',
    },
    '63430c8348c610068bcdc474:63430c8348c610068bcdc43c': { asset: 'sol', network: 'solana' },
    '69789e4635ce8cd4b1aec204:69789afd35ce8cd4b1aec202': { asset: 'trx', network: 'tron' },
    '68f5fcb1b06a0c9bb6cbec43:68e8c8fbb06a0c9bb6cbec2d': {
        asset: 'usdc',
        network: 'arbitrum',
    },
    '672a189115f34893ea4cad97:671a2d7168ef24934ca70622': { asset: 'usdc', network: 'base' },
    '63fdfb232c62da4b72b2d5b6:63430c8348c610068bcdc443': {
        asset: 'usdc',
        network: 'ethereum',
    },
    '63430c8348c610068bcdc482:63430c8348c610068bcdc43c': {
        asset: 'usdc',
        network: 'solana',
    },
    '6abd130c7238ce6334257b27:6a8d7786f1b1f72945bd9a8e': {
        asset: 'usdg',
        network: 'robinhood',
    },
    '6a9052363117b3882e02acaf:63430c8348c610068bcdc43c': {
        asset: 'usdp',
        network: 'solana',
    },
    '6426bd3f9a969530039a1a86:63430c8348c610068bcdc443': {
        asset: 'usdt',
        network: 'ethereum',
    },
    '63430c8348c610068bcdc496:63430c8348c610068bcdc43c': {
        asset: 'usdt',
        network: 'solana',
    },
    '6970bd5ddccc719ee90b1057:63430c8348c610068bcdc43c': { asset: 'xo', network: 'solana' },
    '694547473bbb8d665280685d:6945465f3bbb8d665280685a': { asset: 'xpl', network: 'plasma' },
};
const ASSET_KEYS = new Set([
    'bnb',
    'btc',
    'doge',
    'eth',
    'hype',
    'pyusd',
    'sol',
    'usdc',
    'usdg',
    'usdp',
    'usdt',
    'trx',
    'xo',
    'xpl',
]);
const NETWORK_KEYS = new Set([
    'abstract',
    'arbitrum',
    'base',
    'bitcoin',
    'bsc',
    'doge',
    'ethereum',
    'hypercore',
    'hyperliquid',
    'megaeth',
    'plasma',
    'robinhood',
    'solana',
    'tron',
]);
export function cryptoDepositArtwork(route) {
    return {
        asset: `asset-${ASSET_KEYS.has(route.assetArtworkKey) ? route.assetArtworkKey : 'unknown'}.png`,
        network: `network-${NETWORK_KEYS.has(route.networkArtworkKey) ? route.networkArtworkKey : 'unknown'}.png`,
    };
}
export function cryptoDepositArtworkKeys(currencyId, blockchainId) {
    const value = PROVIDER_ARTWORK[`${currencyId}:${blockchainId}`];
    return value
        ? { ...value, explicit: true }
        : { asset: 'unknown', network: 'unknown', explicit: false };
}
